// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"b81b2802","312":"d00a7c26","313":"f53b2d4e","341":"fa432fe5","444":"9b0c0434","453":"20c6be7e","667":"d5faaff3","682":"fc7e7621","758":"078bd490","916":"e4791218","932":"391f4b9b"}[chunkId] + ".chunk.js";
};